// extracted by mini-css-extract-plugin
module.exports = {"commonWrapper":"style_commonWrapper__LpVDE"};